<app-block-list [blockIdList]="body"></app-block-list>
